import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  buttonsWrapper: {
    display: 'flex',
    marginBottom: '9.6rem',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  imCelticsButtonsWrapper: {
    display: 'flex',
    margin: '0 0 1.6rem 1.6rem',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  imCelticsDisclaimer: {
    fontSize: '1.2rem',
    lineHeight: '1.6rem',
    color: colors.neutral[800],
    textAlign: 'center',
    marginTop: '0.8rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
